import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { LinkSimple } from '@phosphor-icons/react';
import A1GA from '../../helpers/A1GA';
import Button from '../button/Button';


class MobileShare extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showShare: false,
        };

        this._runMobileShare = this._runMobileShare.bind(this);
    }

    componentDidMount() {
        if (navigator.share) {
            this.setState({
                showShare: true,
            });
        }
    }

    _runMobileShare() {
        if (navigator.share) {
            navigator.share({
                title: 'Ouvi falar na Antena 1',
                text: this.props.text,
                url: this.props.location,
            })
                .then(() => {
                    A1GA.event({
                        category: 'Share Mobile',
                        action: 'Successful share',
                        nonInteraction: true,
                    });
                })
                .catch((error) => {
                    A1GA.event({
                        category: 'Share Mobile',
                        action: `Error sharing: ${error}`,
                        nonInteraction: true,
                    });
                });
        }
    }

    render() {
        if (this.state.showShare) {
            return (
                <React.Fragment>
                    <Button title="Compartilhar" onClick={this._runMobileShare}>
                        <div className="tw-transform tw-transition-all tw-duration-300 group-hover:tw--translate-y-1">
                            <LinkSimple weight="bold" size={18} />
                        </div>
                    </Button>
                </React.Fragment>
            );
        }

        return (null);
    }
}

MobileShare.propTypes = exact({
    location: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    styleEffect: PropTypes.string,
    // eslint-disable-next-line react/no-unused-prop-types
    styleBtn: PropTypes.object,
});

export default MobileShare;
